import * as React from "react";
import api from "apiSingleton";

// scss
import classes from "./ModalKitchenStopList.module.scss";

// helpers
import { withLoading } from "utils/helpers/withLoading";

// components
import Select from "components/ui-kit/Select";
import ButtonIcon from "components/ui-kit/ButtonIcon";

// save icon
import SaveIcon from "@mui/icons-material/Save";

// custom select components
import selectComponents from "./selectComponents";

export const ModalContent = ({
  // kitchenCode,  
  closeModal,
  updateKitchen,
  updateKitchenForm,
  editKitchens: {
    stop_list: stopList = [],
  },
}) => {
  const [isLoad, setIsLoad] = React.useState(false);
  const [defaultOptions, setDefaultOptions] = React.useState([]);

  const loadOptions = React.useCallback(async (search) => {
    const response = await api.products.getList({
      short_projection: true,
      status: 1,
      search,
    });

    const options = response.data?.map(({ id: value, title_ua: label, restaurant_code: restaurant }) => ({
      label,
      value,
      restaurant,
    }));

    setDefaultOptions(options);
    return options;

  }, []);

  const onUpdateKitchen = React.useCallback(async () => {
    await withLoading(setIsLoad, updateKitchen);
    closeModal();
  }, [closeModal]);

  const onChange = React.useCallback(({ valueKey, value }) => {
    updateKitchenForm(valueKey, value);
  }, [updateKitchenForm]);

  return (
    <div className="cont-modal-info">

      <div className={classes.modalBody}>

        <Select
          defaultOptions={defaultOptions}
          selectedOption={stopList}
          loadOptions={loadOptions}
          valueKey="stop_list"
          label="Пошук позиції"
          mode="primary"
          components={selectComponents}
          onChange={onChange}
          closeOnSelect={false}
          isSearchable
          cacheOptions
          isMulti
          async
        />

        <div className={classes.btnWrapper}>
          <ButtonIcon
            title="Зберегти"
            onClick={onUpdateKitchen}
            icon={<SaveIcon />}
            isLoad={isLoad}
            positionIcon="left"
            colorBg="green"
          />
        </div>

      </div>
    </div>
  );
};
